/* this file added by Bearer Web Developer  */
import React from 'react';
import styles from './businessName.module.scss';
import { useAppState } from '../../../../states/app-state';
import { useThemeMode } from '../../../../states/contexts/theme';

const BusinessName: React.FC = () => {
    const appState = useAppState();
    const activeManageOrder = appState?.ReservedOrders?.activeManageOrder;
    const getShopifyOrderNumber = () => {
        const data = activeManageOrder?.shopify_order_url?.split('/');
        if (data) return (data[data?.length - 1]);
    }
    const { theme } = useThemeMode();
    return (
        <a className={styles.business_name} data-theme={theme} href={activeManageOrder?.shopify_order_url || ''}>  {/* data-theme property added by Bearer Web Developer */}
            {
                theme === "dark" ? <img src="/confirmation-number-white.svg" alt="" width={20} height={20} /> :
                    <img src="/confirmation-number.webp" alt="" width={20} height={20} />
            }
            {/* <span>{activeManageOrder?.business_name || 'Seyco Invoice No.'} : {activeManageOrder?.client_order_number}</span> */}
           {'Shopify Order'} : <span> {getShopifyOrderNumber() || ''}</span>
        </a>
    )
}
export default BusinessName;